var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTvB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.95431 0 0 8.9543 0 20V40C0 51.0457 8.9543 60 20 60H40C51.0457 60 60 51.0457 60 40V20C60 8.95431 51.0457 0 40 0H20ZM40.303 18.9986C41.9215 18.5432 42.7601 18.1793 44.1919 17.4292C43.7395 18.7022 42.7778 20.0972 41.5657 20.9342C42.9504 20.6967 43.7049 20.5303 45 19.9402C44.0097 21.4328 43.3133 22.1336 41.9192 23.236C41.9192 39.8716 26.1616 46.8292 15 39.453C19.0683 39.6607 21.0176 39.0338 23.9899 36.7851C20.8227 36.228 19.517 35.3247 18.2828 32.3385C19.4632 32.3862 20.0707 32.3809 21.0101 32.2861C17.353 30.7711 16.4423 29.29 16.1616 25.9039C17.2373 26.4362 17.8269 26.6254 18.8384 26.6363C16.0101 24.3345 15.5051 21.0388 16.9697 18.1616C20.404 22.1374 24.6465 24.4392 29.7475 24.8054C28.7374 16.4876 37.5252 15.2844 40.303 18.9986Z",
    fill: "url(#paint0_linear_676_807)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_676_807",
    x1: 30,
    y1: 16.0386,
    x2: 47.1172,
    y2: 50.4452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00637B",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FDCE7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvB);
export default __webpack_public_path__ + "static/media/tv_b.9e6564e1eecd75269ddf0e8eb9cd58a8.svg";
export { ForwardRef as ReactComponent };